module.exports = __webpack_public_path__ + "static/img/fbbs.6b4a4f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/fbbs.jpg
// module id = u1RP
// module chunks = 0